import { render, staticRenderFns } from "./editFoot.vue?vue&type=template&id=c718d566&scoped=true&"
import script from "./editFoot.vue?vue&type=script&lang=js&"
export * from "./editFoot.vue?vue&type=script&lang=js&"
import style0 from "./editFoot.vue?vue&type=style&index=0&id=c718d566&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c718d566",
  null
  
)

export default component.exports